export interface Product {
  id: string
  name: string
  price: number
  category: string
  image: string
  altText: string
  isWIC: boolean
  isEBT: boolean
  description?: string
}

export const categories = [
  'Flours & Grains',
  'Fresh Produce',
  'Spices & Seasonings',
  'Oils & Sauces',
]

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Fufu Flour (Plantain)',
    price: 8.99,
    category: 'Flours & Grains',
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&q=80&w=400',
    altText: 'Fufu flour package',
    isWIC: true,
    isEBT: true,
  },
  {
    id: '2',
    name: 'Fresh Plantains (Green)',
    price: 3.49,
    category: 'Fresh Produce',
    image:
      'https://images.unsplash.com/photo-1603833797131-3c0a18fcb6b1?auto=format&fit=crop&q=80&w=400',
    altText: 'Green plantains',
    isWIC: false,
    isEBT: true,
  },
  {
    id: '3',
    name: 'Jollof Rice Seasoning',
    price: 5.99,
    category: 'Spices & Seasonings',
    image:
      'https://images.unsplash.com/photo-1596040033229-a0b13b6a6c0e?auto=format&fit=crop&q=80&w=400',
    altText: 'Jollof rice seasoning',
    isWIC: false,
    isEBT: true,
  },
  {
    id: '4',
    name: 'Palm Oil (Red)',
    price: 12.99,
    category: 'Oils & Sauces',
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?auto=format&fit=crop&q=80&w=400',
    altText: 'Red palm oil bottle',
    isWIC: false,
    isEBT: true,
  },
  {
    id: '5',
    name: 'Cassava Flour',
    price: 7.49,
    category: 'Flours & Grains',
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&q=80&w=400',
    altText: 'Cassava flour',
    isWIC: true,
    isEBT: true,
  },
  {
    id: '6',
    name: 'Scotch Bonnet Peppers',
    price: 4.99,
    category: 'Fresh Produce',
    image:
      'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&q=80&w=400',
    altText: 'Scotch bonnet peppers',
    isWIC: false,
    isEBT: true,
  },
  {
    id: '7',
    name: 'Yam (Fresh)',
    price: 6.99,
    category: 'Fresh Produce',
    image:
      'https://images.unsplash.com/photo-1568584711075-3d021a7c3ca3?auto=format&fit=crop&q=80&w=400',
    altText: 'Fresh yam',
    isWIC: false,
    isEBT: true,
  },
  {
    id: '8',
    name: 'Egusi Seeds (Ground)',
    price: 9.99,
    category: 'Spices & Seasonings',
    image:
      'https://images.unsplash.com/photo-1596040033229-a0b13b6a6c0e?auto=format&fit=crop&q=80&w=400',
    altText: 'Ground egusi seeds',
    isWIC: false,
    isEBT: true,
  },
]

export const recipeBundles = [
  {
    title: 'Jollof Rice Essentials',
    description: 'Everything you need for authentic Jollof rice',
    products: [mockProducts[2], mockProducts[3], mockProducts[5]],
    totalPrice: 23.97,
    savings: 3.0,
  },
  {
    title: 'Fufu Feast Bundle',
    description: 'Complete ingredients for traditional fufu',
    products: [mockProducts[0], mockProducts[4], mockProducts[6]],
    totalPrice: 23.47,
    savings: 2.5,
  },
]
